import React from 'react';
import { Box } from '@mantine/core';

interface SidebarOverlayProps {
  visible: boolean;
  onClick: () => void;
  zIndex?: number;
}

export const SidebarOverlay: React.FC<SidebarOverlayProps> = ({ visible, onClick, zIndex = 1000 }) => {
  if (!visible) return null;

  return (
    <Box
      onClick={onClick}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex,
        transition: 'opacity 0.3s ease-in-out'
      }}
    />
  );
};
